import axios from "axios";
import { AuthHeaders, decryptResponse } from "./util";
var qs = require('qs');

export const getPiplineStageReport = async (
    fromDate,
    toDate,
    metro
) => {
    try {
        const response = await axios.get(`/api/pipelineStageReport?fromDate=${fromDate}&toDate=${toDate}`,
        {
            'params': { 'metro': metro},
            'paramsSerializer': function (params) {
              return qs.stringify(params, { arrayFormat: 'repeat' })
            },
            'headers': AuthHeaders()
          })
        if (response.status === 200) {
            response.data = decryptResponse(response?.data);
            return response?.data;
        }
    else return "Something went wrong";
    } catch (error) {
        return error.response.data;
    }
}